import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import { Fragment, useState } from 'react';

import useNutritionExists from './hooks/useNutritionExists';
import InfoIcon from './ic_info.svg';
import SearchIcon from './ic_search.svg';
import ImageModal from './ImageModal';

interface Props {
    imageUrls?: string[];
    itemId: string;
}

/**
 * 상품 이미지 우측 상단의 영양정보 / 이미지 상세보기 버튼
 */
function ItemInfoActions({ imageUrls, itemId }: Props) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const nutritionExists = useNutritionExists(itemId);
    const hasImages = !!imageUrls && imageUrls.length > 0;
    return (
        <Fragment>
            {(nutritionExists || hasImages) && (
                <Container nutritionExists={nutritionExists}>
                    {nutritionExists && (
                        <Link activityName='ItemNutritionModal'
                            id='item-nutrition-button'
                            activityParams={{ itemId }}>
                            <IconButton as='span'>
                                <img src={InfoIcon} alt='영양정보' width={25} height={24}/>
                            </IconButton>
                        </Link>
                    )}
                    {hasImages && (
                        <IconButton type='button'
                            id='item-image-button'
                            onClick={() => setIsOpen(true)}>
                            <img src={SearchIcon} alt='이미지 크게 보기' width={25} height={24}/>
                        </IconButton>
                    )}
                </Container>
            )}
            {hasImages && (
                <ImageModal images={imageUrls}
                    setIsOpen={setIsOpen}
                    isOpen={isOpen} />
            )}
        </Fragment>
    );
}

// 가운데 정렬된 110px 이미지의 우측 상단에 걸치도록 배치 (Swiper 의 z-index: 1 위로)
const Container = styled('div', {
    shouldForwardProp: (prop) => prop !== 'nutritionExists',
})<{
    nutritionExists: boolean;
}>`
    align-items: center;
    background-color: var(--color-background-raised);
    border-radius: var(--radius-full);
    column-gap: var(--spacing-1);
    display: flex;
    height: 24px;
    left: ${({ nutritionExists }) => `calc(50% + ${nutritionExists ? 27 : 40}px)`};
    padding: 0 1px;
    position: absolute;
    top: 22px;
    z-index: 2;
    overflow: hidden;

    a {
        display: flex;
    }
`;

const IconButton = styled.button`
    cursor: pointer;
    display: flex;
    width: var(--spacing-6);
    height: var(--spacing-6);
    align-items: center;
    justify-content: center;
    ${pressActionEffect}

    img {
        display: block;
    }
`;

export default ItemInfoActions;
